import { FEMALE, MALE, PATIENT_TYPE_ADULT, PATIENT_TYPE_OBSTETRIC, PATIENT_TYPE_PEDIATRIC } from 'src/app/global';
import { FormOption } from 'src/app/shared/models/form-option.model';

export const minMeasurement = 0;

/**
 * The maximum age that can be input in the age FormControl.
 */
export const maxAge = 130;

/**
 * The maximum number of kilograms that can be input in the weight FormControl.
 */
export const maxWeight = 300;

/**
 * The maximum number of feet that can be input in the heightFeet FormControl.
 */
export const maxFeet = 10;

/**
 * The maximum number of inches that can be input in the heightInches FormControl.
 */
export const maxInches = 11;

/**
 * The options for the "Code Status" input.
 */
export const codeStatusOptions: FormOption[] = [
  new FormOption('Full'),
  new FormOption('Limited'),
  new FormOption('DNR'),
  new FormOption('Comfort Care'),
];

/**
 * The options for the "Sex" input.
 */
export const sexOptions: FormOption[] = [new FormOption(FEMALE), new FormOption(MALE)];

/**
 * The options for the type of patient
 */
export const patientTypeOptions: FormOption[] = [
  new FormOption(PATIENT_TYPE_ADULT),
  new FormOption(PATIENT_TYPE_PEDIATRIC),
  new FormOption(PATIENT_TYPE_OBSTETRIC),
];
